import { DashboardActionTypes } from "../models/dashboardActions";

import { INCREASE_PACK_TOTAL_PLAN } from "../types";

export default (_id: string): DashboardActionTypes => ({
    type: INCREASE_PACK_TOTAL_PLAN,
    payload: _id,
});
